import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

import { Box, BoxProps } from '@rover/kibble/core';

import { DropdownState } from './Dropdown.constants';
import { OptionProp } from './Dropdown.types';

const LI = (props: React.ComponentProps<typeof Box>): JSX.Element => <Box webAs="li" {...props} />;

const ListItem = styled(LI)<BoxProps>`
  margin: 0;
  padding: ${({ theme }) => `${theme.space['2x']} ${theme.space['3x']}`};

  background-color: ${({ theme }) => theme.background.primary};
  list-style-type: none;
  text-align: left;

  &:hover {
    background-color: ${({ theme }) => theme.background.secondary};
  }

  &.is-focused {
    color: ${({ theme }) => theme.colors.interactive_text.primary_active};
  }
`;

export type Props = {
  className?: string;
  isFocused: boolean;
  isSelected: boolean;
  option: OptionProp;
} & React.ComponentProps<typeof ListItem>;

const DropdownOption = ({
  className,
  isFocused,
  isSelected,
  option,
  ...props
}: Props): JSX.Element => {
  // Explore alternatives to classnames: https://roverdotcom.atlassian.net/browse/DEV-42053
  const classes = classnames(className, {
    [DropdownState.FOCUSED_OPTION.value]: isFocused,
    [DropdownState.SELECTED_OPTION.value]: isSelected,
  });
  return (
    <ListItem
      className={classes}
      aria-selected={isSelected}
      webProps={{
        role: 'option',
        tabIndex: -1,
      }}
      {...props}
    >
      {option.label}
    </ListItem>
  );
};

export default DropdownOption;
